
import { useEffect } from 'react';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

import { UserContextProvider } from 'contexts/user';
import { ModalContextProvider } from 'contexts/modal';
import { ToastContextProvider } from 'contexts/toast';

import { theme } from 'utils/theme'
import './style.css'
import { config } from 'config'
import Wrapper from 'containers/wrapper';
import Modal from 'components/common/modal';
import Toast from 'components/common/toast';

const App = () => {

  useEffect(() => {
    document.title = `${config.env.toUpperCase()} Dashboard`
  }, [])

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <ToastContextProvider>
          <ModalContextProvider>
            <UserContextProvider>
              <Wrapper />
              <Modal />
              <Toast />
            </UserContextProvider>
          </ModalContextProvider>
        </ToastContextProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
